import LoadableImage from "components/LoadableImage"
import { DOTS_PROJECT_CONTRACT_ADDRESS, getFeaturedProject } from "config"
import { CompositeSourceDot } from "utils/compositeSourceDots"
import { getArtBlocksImageUrl } from "utils/artBlocksUrls"

interface Props {
  sourceDots: CompositeSourceDot[]
  loading: boolean
  error: boolean
}

const dotsProject = getFeaturedProject("dots")

const getDotLabel = (dot: CompositeSourceDot) =>
  typeof dot.invocation === "number" ? `No. ${dot.invocation}` : dot.tokenId

const ComposedOfDots = ({ sourceDots, loading, error }: Props) => {
  if (!dotsProject) return null
  if (!loading && !error && sourceDots.length === 0) return null

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between gap-4 mb-4">
        <h2 className="gallery-label text-gallery-muted">Composed of</h2>
        {sourceDots.length > 0 && (
          <span className="gallery-label text-gallery-muted">{sourceDots.length}</span>
        )}
      </div>

      {loading && (
        <div className="gallery-composed-state">Reading source dots</div>
      )}

      {!loading && error && (
        <div className="gallery-composed-state text-red-500">Unable to load source dots.</div>
      )}

      {!loading && !error && sourceDots.length > 0 && (
        <div className="gallery-composed-grid" role="list">
          {sourceDots.map((dot) => {
            const label = getDotLabel(dot)

            return (
              <a
                key={dot.tokenId}
                href={`${dotsProject.detailPath}/${dot.tokenId}`}
                className="gallery-composed-dot"
                aria-label={`Open Dots ${label}`}
                role="listitem"
              >
                <span className="gallery-composed-dot-art">
                  <LoadableImage
                    src={getArtBlocksImageUrl({
                      chainId: dotsProject.chainId,
                      contractAddress: DOTS_PROJECT_CONTRACT_ADDRESS,
                      tokenId: dot.tokenId,
                    })}
                    alt={`Dots ${label}`}
                    loading="lazy"
                    decoding="async"
                    wrapperClassName="h-full w-full"
                    className="h-full w-full object-contain"
                    loaderLabel="Loading dot"
                    hideLoaderLabel
                  />
                </span>
                <span className="gallery-composed-dot-label">{label}</span>
              </a>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default ComposedOfDots
